import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

interface ColorProps {
    themeColor: string;
    themeBg: string;
}

export const CLARITY_LEVELS: Record<
    number,
    { color: string; bg: string; label: string }
> = {
    1: {
        color: '#ff6b6b',
        bg: 'rgba(255,107,107,0.12)',
        label: 'Low — more info needed'
    },
    2: {
        color: '#ffa94d',
        bg: 'rgba(255,169,77,0.12)',
        label: 'Fair — details recommended'
    },
    3: {
        color: '#ffd43b',
        bg: 'rgba(255,212,59,0.12)',
        label: 'Good — ready to proceed'
    },
    4: {
        color: '#69db7c',
        bg: 'rgba(105,219,124,0.12)',
        label: 'Excellent — fully defined'
    }
};

export const BadgeContainer = styled(Box)<ColorProps>`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 12px;
    margin-bottom: 16px;
    border-radius: 6px;
    background-color: ${({ themeBg }) => themeBg};
    border: 1px solid ${({ themeColor }) => themeColor}30;
`;

export const ScoreLabel = styled(Typography)<ColorProps>`
    font-size: 13px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    color: ${({ themeColor }) => themeColor};
    line-height: 1;
`;

export const DescriptionLabel = styled(Typography)<ColorProps>`
    font-size: 12px;
    font-family: 'Inter', sans-serif;
    color: ${({ themeColor }) => themeColor};
    opacity: 0.8;
    line-height: 1;
`;
